import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import Cookie from "js-cookie";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const http = axios.create({
  //通用请求地址前缀
  // baseURL: "http://localhost:8080/Main/action", //本地测试（开发环境）
  baseURL: "https://card.xixinyiban.com/Main/action", //打包正式（生产环境）
  timeout: 10000, //超时时间
});

// 添加请求拦截器
http.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    config.headers.Token = Cookie.get("token");
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
http.interceptors.response.use(
  function (response) {
    const { code, msg } = response.data;
    if (code == 201) {
      Message({
        message: msg,
        type: "error",
      });
      Cookie.remove("token");
      Cookie.remove("is_root");
      location.href = location.origin + "/#/login";
    } else if (code !== 200) {
      Message({
        message: msg,
        type: "error",
      });
    }
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default http;
